import copyFieldValueForRegistration
  from '../actions/copyFieldValueForRegistration'

export default [copyFieldValueForRegistration]



// WEBPACK FOOTER //
// ./src/modules/login/chains/copyFieldValueForRegistration.js